import React, { useState } from "react";
import { MessageCircle, X, Phone } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { WhatsAppSimulator } from "./WhatsAppSimulator";

export function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);

  const whatsappNumber = "+252613737777"; // Updated with actual bank number from existing WhatsAppButton
  const whatsappLink = `https://wa.me/${whatsappNumber.replace('+', '')}`;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-4">
      {/* Chat Window */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            className="mb-4 w-[400px] max-w-[90vw] shadow-2xl rounded-2xl overflow-hidden border border-gray-200"
          >
            <div className="relative h-[600px]">
               <WhatsAppSimulator />
               <button 
                className="absolute top-3 right-12 text-white hover:bg-white/20 p-2 rounded-full z-20 transition-colors"
                onClick={() => setIsOpen(false)}
               >
                 <X size={20} />
               </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Floating Buttons */}
      <div className="flex flex-col gap-3">
        {/* Real WhatsApp Redirect */}
        <motion.a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          className="bg-[#25D366] text-white p-4 rounded-full shadow-lg flex items-center justify-center hover:bg-[#128C7E] transition-colors"
          title="Chat on WhatsApp"
        >
          <Phone size={24} />
        </motion.a>

        {/* AI Chatbot Toggle */}
        {/* <motion.button
          onClick={() => setIsOpen(!isOpen)}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          className={`${
            isOpen ? "bg-gray-500" : "bg-[#017EFF]"
          } text-white p-4 rounded-full shadow-lg flex items-center justify-center transition-colors`}
          title="Open AI Assistant"
        >
          {isOpen ? <X size={24} /> : <MessageCircle size={24} />}
        </motion.button> */}
      </div>
    </div>
  );
}
